import axios from 'axios';
import { getExpressAPIHost } from '../../../../utils';

const deleteReport = async ({ resourceId, endPoint = 'route-sessions', report = 'delivery-report', resourceTitle = 'delivery report' }) => {
    try {
        if (!resourceId) throw new Error('ID is required.');
        const response = await axios.delete(`${getExpressAPIHost()}/${endPoint}/${report}/${resourceId}`);
        return response.data;
    } catch (err) {
        throw new Error(`Unable to delete ${resourceTitle}: ${err.message}`);
    }
};

export default deleteReport;
